import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
		computed,
		getCurrentInstance,
		provide,
		readonly
	} from 'vue'

	
	const __default__ = { name: 'VFieldset' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		disabled: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

const props = __props;

	

	const fieldsetDisabled = computed(() => {
		return props.disabled
	})
	provide('fieldsetDisabled', readonly(fieldsetDisabled))

	const fieldsetRequired = computed(() => {
		return props.required
	})
	provide('fieldsetRequired', readonly(fieldsetRequired))

	const labelId = 'label-' + getCurrentInstance()?.uid
	provide('labelId', labelId)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", {
    "aria-labelledby": labelId,
    class: _normalizeClass('[&>*+[data-slot=control]]:mt-6 [&>[data-slot=text]]:mt-1')
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})